import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Grid, Box, Paper } from '@mui/material';
import MainContentHeader from 'src/shared/components/atoms/mainContentHeader';
import GridWrapper from 'src/shared/components/organisms/gridWrapper';
import MemberGroupEmailActionButtons from 'src/modules/groupMessageEmail/components/groupMessageEmailActionButtons';
import PageTabNavigation, { PageTabItem } from 'src/shared/components/navigations/pageTabNavigation';
import { RoutesEnum } from 'src/shared/models/enums/routes.enum';
import { EmailTemplatePickerModal } from '../components/emailTemplatePickerModal';

const emailPageTabs: PageTabItem[] = [
  { label: 'groupMessage:overview.sections.email', route: RoutesEnum.GroupMessageEmailOverview },
  { label: 'groupMessage:overview.sections.unsubscribed', route: RoutesEnum.GroupMessageEmailUnsubscribed },
];

export const GroupMessageEmailPage = () => {
  const { t } = useTranslation(['groupMessage']);
  const [openEmailTemplatePickerModal, setOpenEmailTemplatePickerModal] = useState<boolean>(false);

  return (
    <>
      <GridWrapper>
        <Grid item xs='auto'>
          <MainContentHeader title={t('groupMessage:overview.header')} />
        </Grid>
        <Grid item xs sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-end' }}>
            <MemberGroupEmailActionButtons openTemplatePicker={setOpenEmailTemplatePickerModal} />
          </Box>
        </Grid>
        <Grid item xs={12}>
          <Paper>
            <PageTabNavigation pageTabs={emailPageTabs} />
            <Outlet />
          </Paper>
        </Grid>
      </GridWrapper>
      {openEmailTemplatePickerModal && <EmailTemplatePickerModal open={openEmailTemplatePickerModal} openModal={setOpenEmailTemplatePickerModal} />}
    </>
  );
};
